<template>
	<Button @click="onClick" type="danger" :size="size" :disabled="disabled">
		<template #icon>
			<IconTrash :size="size" style="margin-right: 4px" />
		</template>
		<slot />
	</Button>
</template>

<script>
import Button from './Button.vue'
import IconTrash from '../icon/IconTrash.vue'
import ButtonMixin from './ButtonMixin.js'
export default {
	mixins: [ButtonMixin],
	components: {
		Button,
		IconTrash
	}
}
</script>
